<template>
    <div class="btn-next-container" :class="{'no-margin-bottom': noMarginBottom}">
        <button v-if="btnBack" class="btn c-btn-back" @click="btnBackClick">
            <i class="fas fa-long-arrow-alt-left"></i>
        </button>
        <button class="btn c-btn-next" @click="$emit('click')" :disabled="disabledNext">
            Continuar <i class="fas fa-long-arrow-alt-right"></i>
        </button>
    </div>
</template>

<script>
    export default {
        name: "BtnNext",
        props: {
            btnBack: {
                type: Boolean,
                default: true
            },
            disabledNext: {
                type: Boolean,
                default: false
            },
            urlBack: {
                type: String,
                default: '#'
            },
            noMarginBottom: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            btnBackClick() {
                this.$emit('backClick');
                window.location = this.urlBack;
                // history.go(-1);
            }
        }
    }
</script>

<style scoped>

    .btn-next-container {
        display: flex;
        align-items: center;
        max-width: 380px;
        margin: auto;
        margin-top: 0.5rem;
        background-color: #fff;
    }

    .c-btn-next {
        font-size: 17px;
        width: 100%;
        font-weight: bold;
        padding: 5px;
        margin-top: 10px;
        color: #ffffff;
        background-color: #ff3366;
        border-color: #db2d49;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
    }

    .c-btn-back {
        font-size: 17px;
        font-weight: bold;
        padding: 5px 15px;
        margin-top: 10px;
        color: #0071bc;
        border-color: #0071bc;
        border-width: 2px;
        border-radius: 0;
        margin-bottom: 0.5em;
        margin-right: 0.7em;
    }

    .c-btn-next:hover {
        background-color: #db2d49;
    }

    .c-btn-next:disabled, .c-btn-back:disabled {
        background-color: #b4b3b3;
        color: #808081;
        border-color: #808081;
        opacity: 1;
    }

    @media (min-width: 575px) {

        .no-margin-bottom .c-btn-next,
        .no-margin-bottom .c-btn-back{
            margin-bottom: 0;
        }
    }

</style>
